import { css, Grid, styled } from '@mui/material';
import React from 'react';

import ProjectTableSkeleton from './project-table-skeleton';
import BarGraphSkeleton from '../../base/graph-card/bar-graph-skeleton';
import GraphSkeleton from '../../base/graph-card/graph-skeleton';
import Spacer, { spc } from '../../base/spacer';
import ProjectDetailsSkeleton from '../../project/dashboard/project-details-skeleton';

const ComplianceLoadingSkeleton: React.FC = () => {
  return (
    <>
      <div>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <div className="grid">
              <div>
                <div className="details-grid">
                  {[1, 2, 3, 4].map((_, idx) => (
                    <ProjectDetailsSkeleton key={idx} />
                  ))}
                </div>
                <Spacer pb={spc.xs} />
                <div className="grid">
                  <GraphSkeleton title="RESIDUAL RISK" />
                  <GraphSkeleton title="POLICY COMPLIANCE" />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        {/* <div className="grid" style={{ paddingTop: '24px' }}>
          <BarGraphSkeleton title="PROJECTS BY SECTOR/FUNCTION" />
          <BarGraphSkeleton title="POLICY COVERAGE BY JURISDICTION" />
        </div> */}
      </div>
      <Spacer py={spc.xs} />
      {/* <ProjectTableSkeleton title="PROJECTS" /> */}
    </>
  );
};

export default styled(ComplianceLoadingSkeleton)(
  ({ theme }) => css`
    .details-grid {
      display: grid;
      gap: 16px;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      ${theme.breakpoints.up('sm')} {
        gap: 24px;
        grid-template-columns: repeat(4, minmax(140px, 1fr));
      }
    }
    .grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    }
  `
);
